import { defineStore } from 'pinia';

export const useNewDataFormErrorsCargoPickUpStore = defineStore({
  id: 'newDataFormErrorsCargoPickUpStore',
  state: () => ({
    errorSenderAddressClick: '',
    errorSenderTime: '',

    errorConsigneeAddressClick: '',
    errorConsigneeTime: '',
  }),
  getters: {
    getSenderErrors(state) {
      return { errorSenderAddressClick: state.errorSenderAddressClick, errorSenderTime: state.errorSenderTime };
    },
    getConsigneeErrors(state) {
      return { errorConsigneeAddressClick: state.errorConsigneeAddressClick, errorConsigneeTime: state.errorConsigneeTime };
    },
  },
});
